export default __webpack_public_path__ + "static/media/Catacomb Legguards.3e1a4b78.jpg";